let classId = -1;

export const setClassId = (id: number) => (classId = id);

export const getClassId = (): number => classId;
